import React from "react";
import { useDispatch } from "react-redux";
import { Button, Container } from "semantic-ui-react";
import { openModal } from "../../../app/common/modals/modalReducer";
import { saveAs } from "file-saver";
import CardListItem from "../../card/CardListItem";
import { useMediaQuery } from "react-responsive";

export default function LayoutListItem({ card }) {
  const ismobile = useMediaQuery({ query: "(max-width: 768px)" });
  const dispatch = useDispatch();

  return (
    <CardListItem
      card={card}
      collection='layouts'
      direction={ismobile ? "vertical" : "horizontal"}
      compact={ismobile ? true : false}
    >
      <>
        <Button.Group size='tiny' floated='right'>
          <Button
            // content='Comment'

            icon='file alternate'
            onClick={() => {
              dispatch(
                openModal({
                  modalType: "CommentModal",
                  modalProps: { data: card, collectionDB: "layouts" },
                })
              );
            }}
          />
        </Button.Group>
        <Button.Group size='tiny' floated='right'>
          {card.pdfUrl && (
            <Button
              // as='a'
              onClick={() => {
                var xhr = new XMLHttpRequest();
                xhr.responseType = "blob";
                xhr.onload = (event) => {
                  console.log("loaded...");
                  var blob = xhr.response;
                  saveAs(blob, `${card.title}.pdf`);
                };
                xhr.open("GET", card.pdfUrl);
                xhr.send();
              }}
              icon='download'
            />
          )}

          <Button
            content='PDF'
            icon='upload'
            onClick={() => {
              dispatch(
                openModal({
                  modalType: "CommitFileFormModal",
                  modalProps: {
                    data: card,
                    field: "pdf",
                    collection: "layouts",
                  },
                })
              );
            }}
          />
        </Button.Group>

        <Button.Group size='tiny' floated='right'>
          {card.dwgUrl && (
            <Button
              // as='a'
              onClick={() => {
                var xhr = new XMLHttpRequest();
                xhr.responseType = "blob";
                xhr.onload = (event) => {
                  console.log("loaded...");
                  var blob = xhr.response;
                  saveAs(blob, `${card.title}.dwg`);
                };
                xhr.open("GET", card.dwgUrl);
                xhr.send();
              }}
              icon='download'
            />
          )}
          <Button
            content='DWG'
            icon='upload'
            onClick={() => {
              dispatch(
                openModal({
                  modalType: "CommitFileFormModal",
                  modalProps: {
                    data: card,
                    field: "dwg",
                    collection: "layouts",
                  },
                })
              );
            }}
          />
        </Button.Group>
      </>
    </CardListItem>
  );
}
